export const mapStyles = [
    {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f7f1df"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#d0e3b4"
            }
        ]
    },
    {
        "featureType": "landscape.natural.terrain",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.medical",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#fbd3da"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#bde6ab"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffe15f"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#efd151"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "black"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "transit.station.airport",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#cfb2db"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#a2daf2"
            }
        ]
    }
]

export const bowlIcon = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 326 149"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cpath fill="%2350c4d0" d="M325.69 148.098C318.759 65.169 248.503 0 162.845 0S6.93 65.169 0 148.098z"/%3E%3Cpath fill="%23272460" d="M302.478 148.098C296.06 76.965 236.002 21.211 162.846 21.211S29.63 76.965 23.213 148.098z"/%3E%3Cpath fill="%23eb008a" d="M278.286 148.098c-6.753-57.123-55.857-101.453-115.441-101.453S54.157 90.975 47.404 148.098z"/%3E%3Cpath fill="%23f7951d" d="M254.237 148.098c-6.594-44.061-44.997-77.874-91.392-77.874s-84.798 33.813-91.391 77.874z"/%3E%3Cpath fill="%23fcde00" d="M230.919 148.098c-6.338-31.451-34.403-55.157-68.074-55.157s-61.736 23.706-68.074 55.157z"/%3E%3C/g%3E%3C/svg%3E';

export const defaultShuttleIcon = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 31 46"%3E%3Ccircle cx="15.304" cy="16.166" r="14.283" fill="%23fff"/%3E%3Cpath fill="%23000" fill-rule="evenodd" d="M21.108 19.305c-.703 0-1.237.534-1.237 1.25 0 .715.534 1.25 1.237 1.25s1.255-.54 1.255-1.25-.54-1.25-1.255-1.25M9.5 19.305c-.716 0-1.25.534-1.25 1.25 0 .715.534 1.25 1.25 1.25.715 0 1.249-.54 1.249-1.25s-.534-1.25-1.25-1.25M17.401 19.695h-4.2c-.502 0-.848.339-.848.841s.346.841.848.841h4.2c.49 0 .841-.345.841-.84 0-.497-.345-.842-.84-.842" clip-rule="evenodd"/%3E%3Cpath fill="%23000" fill-rule="evenodd" d="M15.306 0C6.868 0 0 6.868 0 15.306c0 7.471 3.855 11.571 7.954 18.195l7.352 11.809 7.352-11.81c4.1-6.63 7.955-10.723 7.955-18.194C30.606 6.868 23.738 0 15.306 0m10.56 12.62c0 .514-.377.84-.916.84h-.427v12.03c0 .715-.56 1.274-1.287 1.274h-1.143a1.256 1.256 0 0 1-1.274-1.274v-1.601c-1.922.144-3.818.2-5.519.2s-3.591-.069-5.506-.2v1.6c0 .716-.559 1.275-1.287 1.275H7.364A1.256 1.256 0 0 1 6.09 25.49V13.46h-.433c-.54 0-.917-.326-.917-.84V8.84c0-.515.377-.848.917-.848h.433V6.9c0-1.25.722-1.96 2.04-2.116 2.066-.239 4.703-.364 7.17-.364s5.123.125 7.176.364c1.306.157 2.04.873 2.04 2.116v1.092h.427c.54 0 .917.34.917.848v3.78z" clip-rule="evenodd"/%3E%3Cpath fill="%23000" fill-rule="evenodd" d="M21.586 6.498a61.6 61.6 0 0 0-12.544 0c-.735.075-1.099.49-1.099 1.268v8.582c0 .685.32 1.043.955 1.15 3.974.59 8.814.59 12.82 0 .646-.107.954-.465.954-1.15V7.766c0-.772-.345-1.186-1.092-1.268z" clip-rule="evenodd"/%3E%3C/svg%3E';

export const activeShuttleIcon = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 31 46"%3E%3Ccircle cx="15.304" cy="16.166" r="14.283" fill="%23fff"/%3E%3Cpath fill="%23356129" fill-rule="evenodd" d="M21.108 19.305c-.703 0-1.237.534-1.237 1.25 0 .715.534 1.25 1.237 1.25s1.255-.54 1.255-1.25-.54-1.25-1.255-1.25M9.5 19.305c-.716 0-1.25.534-1.25 1.25 0 .715.534 1.25 1.25 1.25.715 0 1.249-.54 1.249-1.25s-.534-1.25-1.25-1.25M17.401 19.695h-4.2c-.502 0-.848.339-.848.841s.346.841.848.841h4.2c.49 0 .841-.345.841-.84 0-.497-.345-.842-.84-.842" clip-rule="evenodd"/%3E%3Cpath fill="%23356129" fill-rule="evenodd" d="M15.306 0C6.868 0 0 6.868 0 15.306c0 7.471 3.855 11.571 7.954 18.195l7.352 11.809 7.352-11.81c4.1-6.63 7.955-10.723 7.955-18.194C30.606 6.868 23.738 0 15.306 0m10.56 12.62c0 .514-.377.84-.916.84h-.427v12.03c0 .715-.56 1.274-1.287 1.274h-1.143a1.256 1.256 0 0 1-1.274-1.274v-1.601c-1.922.144-3.818.2-5.519.2s-3.591-.069-5.506-.2v1.6c0 .716-.559 1.275-1.287 1.275H7.364A1.256 1.256 0 0 1 6.09 25.49V13.46h-.433c-.54 0-.917-.326-.917-.84V8.84c0-.515.377-.848.917-.848h.433V6.9c0-1.25.722-1.96 2.04-2.116 2.066-.239 4.703-.364 7.17-.364s5.123.125 7.176.364c1.306.157 2.04.873 2.04 2.116v1.092h.427c.54 0 .917.34.917.848v3.78z" clip-rule="evenodd"/%3E%3Cpath fill="%23356129" fill-rule="evenodd" d="M21.586 6.498a61.6 61.6 0 0 0-12.544 0c-.735.075-1.099.49-1.099 1.268v8.582c0 .685.32 1.043.955 1.15 3.974.59 8.814.59 12.82 0 .646-.107.954-.465.954-1.15V7.766c0-.772-.345-1.186-1.092-1.268z" clip-rule="evenodd"/%3E%3C/svg%3E';

export const defaultParkRideIcon = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 31 46"%3E%3Ccircle cx="15.304" cy="16.166" r="14.283" fill="%23fff"/%3E%3Cpath fill="%23000" fill-rule="evenodd" d="M21.108 19.305c-.703 0-1.237.534-1.237 1.25 0 .715.534 1.25 1.237 1.25s1.255-.54 1.255-1.25-.54-1.25-1.255-1.25M9.5 19.305c-.716 0-1.25.534-1.25 1.25 0 .715.534 1.25 1.25 1.25.715 0 1.249-.54 1.249-1.25s-.534-1.25-1.25-1.25M17.401 19.695h-4.2c-.502 0-.848.339-.848.841s.346.841.848.841h4.2c.49 0 .841-.345.841-.84 0-.497-.345-.842-.84-.842" clip-rule="evenodd"/%3E%3Cpath fill="%23000" fill-rule="evenodd" d="M15.306 0C6.868 0 0 6.868 0 15.306c0 7.471 3.855 11.571 7.954 18.195l7.352 11.809 7.352-11.81c4.1-6.63 7.955-10.723 7.955-18.194C30.606 6.868 23.738 0 15.306 0m10.56 12.62c0 .514-.377.84-.916.84h-.427v12.03c0 .715-.56 1.274-1.287 1.274h-1.143a1.256 1.256 0 0 1-1.274-1.274v-1.601c-1.922.144-3.818.2-5.519.2s-3.591-.069-5.506-.2v1.6c0 .716-.559 1.275-1.287 1.275H7.364A1.256 1.256 0 0 1 6.09 25.49V13.46h-.433c-.54 0-.917-.326-.917-.84V8.84c0-.515.377-.848.917-.848h.433V6.9c0-1.25.722-1.96 2.04-2.116 2.066-.239 4.703-.364 7.17-.364s5.123.125 7.176.364c1.306.157 2.04.873 2.04 2.116v1.092h.427c.54 0 .917.34.917.848v3.78z" clip-rule="evenodd"/%3E%3Cpath fill="%23000" fill-rule="evenodd" d="M21.586 6.498a61.6 61.6 0 0 0-12.544 0c-.735.075-1.099.49-1.099 1.268v8.582c0 .685.32 1.043.955 1.15 3.974.59 8.814.59 12.82 0 .646-.107.954-.465.954-1.15V7.766c0-.772-.345-1.186-1.092-1.268z" clip-rule="evenodd"/%3E%3C/svg%3E';

export const activeParkRideIcon = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 31 46"%3E%3Ccircle cx="15.304" cy="16.166" r="14.283" fill="%23fff"/%3E%3Cpath fill="%23EB008C" fill-rule="evenodd" d="M21.108 19.305c-.703 0-1.237.534-1.237 1.25 0 .715.534 1.25 1.237 1.25s1.255-.54 1.255-1.25-.54-1.25-1.255-1.25M9.5 19.305c-.716 0-1.25.534-1.25 1.25 0 .715.534 1.25 1.25 1.25.715 0 1.249-.54 1.249-1.25s-.534-1.25-1.25-1.25M17.401 19.695h-4.2c-.502 0-.848.339-.848.841s.346.841.848.841h4.2c.49 0 .841-.345.841-.84 0-.497-.345-.842-.84-.842" clip-rule="evenodd"/%3E%3Cpath fill="%23EB008C" fill-rule="evenodd" d="M15.306 0C6.868 0 0 6.868 0 15.306c0 7.471 3.855 11.571 7.954 18.195l7.352 11.809 7.352-11.81c4.1-6.63 7.955-10.723 7.955-18.194C30.606 6.868 23.738 0 15.306 0m10.56 12.62c0 .514-.377.84-.916.84h-.427v12.03c0 .715-.56 1.274-1.287 1.274h-1.143a1.256 1.256 0 0 1-1.274-1.274v-1.601c-1.922.144-3.818.2-5.519.2s-3.591-.069-5.506-.2v1.6c0 .716-.559 1.275-1.287 1.275H7.364A1.256 1.256 0 0 1 6.09 25.49V13.46h-.433c-.54 0-.917-.326-.917-.84V8.84c0-.515.377-.848.917-.848h.433V6.9c0-1.25.722-1.96 2.04-2.116 2.066-.239 4.703-.364 7.17-.364s5.123.125 7.176.364c1.306.157 2.04.873 2.04 2.116v1.092h.427c.54 0 .917.34.917.848v3.78z" clip-rule="evenodd"/%3E%3Cpath fill="%23EB008C" fill-rule="evenodd" d="M21.586 6.498a61.6 61.6 0 0 0-12.544 0c-.735.075-1.099.49-1.099 1.268v8.582c0 .685.32 1.043.955 1.15 3.974.59 8.814.59 12.82 0 .646-.107.954-.465.954-1.15V7.766c0-.772-.345-1.186-1.092-1.268z" clip-rule="evenodd"/%3E%3C/svg%3E';

export const locationIcon = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 42"%3E%3Cpath fill="%2392288f" d="M14 0c7.712 0 13.994 6.282 14 14 0 6.833-3.526 10.578-7.275 16.642L14 41.443 7.275 30.642C3.525 24.583 0 20.833 0 14 0 6.282 6.282 0 14 0m-.112 6.85a7.032 7.032 0 1 0 .001 14.064 7.032 7.032 0 0 0-.001-14.064"/%3E%3C/svg%3E';

export default {
    mapStyles,
    defaultShuttleIcon,
    activeShuttleIcon,
    defaultParkRideIcon,
    activeParkRideIcon,
    locationIcon,
}
